/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileImportDTO
 */
export interface FileImportDTO {
    /**
     * 
     * @type {string}
     * @memberof FileImportDTO
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileImportDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof FileImportDTO
     */
    employeeId?: string;
    /**
     * 
     * @type {string}
     * @memberof FileImportDTO
     */
    careProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof FileImportDTO
     */
    filter?: string;
}

export function FileImportDTOFromJSON(json: any): FileImportDTO {
    return FileImportDTOFromJSONTyped(json, false);
}

export function FileImportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileImportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'employeeId': !exists(json, 'employeeId') ? undefined : json['employeeId'],
        'careProviderId': !exists(json, 'careProviderId') ? undefined : json['careProviderId'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FileImportDTOToJSON(value?: FileImportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'carePrincipalId': value.carePrincipalId,
        'employeeId': value.employeeId,
        'careProviderId': value.careProviderId,
        'filter': value.filter,
    };
}

